import Guest from '@/layouts/guest';
import React from 'react';
import {Container} from "react-bootstrap";
import ResetPassContent from "@/components/auth/resetpass-content";

const ResetPass: React.FC = () => {
  return (
    <Guest title="فراموشی رمز">
      <Container className="py-5">
        <ResetPassContent />
      </Container>
    </Guest>
  );
}

export default ResetPass;
